<template>
    <div class="up-box flex align-start">
        <el-upload
            :class="{disabled:disabled}"
            :action="FILE_UPLOAD_HOST"
            :data="fileData"
            :accept="'image/*'"
             name="file"
            :show-file-list="false"
            :on-error="uploadError"
            :on-success="uploadSuccess"
            :before-upload="beforeAvatarUpload" :disabled="disabled">
            <el-image v-if="file" :src="BASE_URL + file" class="up-image" :class="type"></el-image>
            <i v-else class=" el-icon-plus up-image-up" :class="type">{{tips}}</i>
        </el-upload>
    </div>
</template>

<script>
import {BASE_URL, FILE_UPLOAD_HOST} from "@/config";
import {TOAST, toast} from "@/utils/utils";

    export default {
        name: "UploadAvatarFile",
        data() {
            return {
                BASE_URL:BASE_URL,
                FILE_UPLOAD_HOST: FILE_UPLOAD_HOST,
            }
        },
        props: {
            type: {
                type: String,
                default: ''
            },
            file: {
                type: String,
                default: ''
            },
            disabled: {
                type: Boolean,
                default: false
            },
            tips:{
                type: String,
                default: '头像'
            },
        },
        computed: {
            user() {
                return this.$store.state.user;
            },
            fileData() {
                return {
                    token: this.user.token,
                }
            }
        },
        created() {

        },
        methods: {
            //  上传钱判断
            beforeAvatarUpload(file) {
                const isLt2M = file.size / 1024 / 1024 < 10;
                if (!isLt2M) {
                    return this.$message.error('上传头像大小不能超过 10MB!');
                }
                this.uping = this.$loading({
                    lock: true,
                    text: "上传中，请稍后",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.2)",
                });
            },
            //  上传成功
            uploadSuccess(res) {
                this.uping.close();
                if (res.code === 200) {
                    this.$emit('uploadAvatar', res.url)
                }else {
                    toast(res.msg,TOAST.error)
                }
            },
            //  上传失败
            uploadError() {
                this.uping.close();
                this.$message({
                    message: "上传出错，请重试！",
                    type: "error",
                    center: true,
                });
            },
        },
        watch: {
            file() {
                this.fileList = this.file
            }
        }
    }
</script>

<style scoped lang="scss">
    .up-box {
        .up-image {
            width: 115px;
            height: 150px;
            border: 1px solid #eeeeee;
            &.picture {
                width: calc(150px * 3);
                height: calc(80px * 3);
            }
        }

        .up-image-up {
            width: 115px;
            height: 150px;
            line-height: 150px;
            position: relative;
            border: 1px solid #eeeeee;
            user-select: none;
            &.picture {
                width: calc(150px * 3);
                height: calc(80px * 3);
                line-height: calc(80px * 3);
            }
            &:before {
                position: absolute;
                content: '+';
                font-size: 26px;
                color: #333333;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -60%);
            }
        }
    }
</style>